import { SET_CHALLENGES, SET_MY_CHALLENGES, ADD_CHALLENGE, SET_MY_CHALLENGES_HISTORIES, SET_CHALLENGES_CACHED, } from "./types";
import { apiCallV2, servicesAPICall } from "../../../utils/api";
import { getAge } from "../../../utils/date";

export const GetChallenges = (status) => async (dispatch, getState) => {

   const res = await apiCallV2(
      "GET",
      "challenges/get",
      "",
      localStorage.getItem("access-token"),
      {
         status: status,
      },
      false
   );

   let list = res.data.challenges.map((cha) => {
      return {
         ...cha,
         statusType: status
      }
   })

   dispatch({
      type: SET_CHALLENGES,
      status: status,
      list: list
   })

   return true;

}

export const EmptyChallenges = () => async (dispatch, getState) => {
   dispatch({
      type: SET_CHALLENGES,
      list: null
   })
}

export const AcceptChallenge = (challenge) => async (dispatch, getState) => {
   const res = await apiCallV2(
      "POST",
      "challenges/accept",
      {
         challenge: challenge,
      },
      localStorage.getItem("access-token"),
   );


   if (res.status == 200) {
      const { account } = getState().User;

      const id = account?.user?.id;
      const { challenges } = getState().Challenge;

      const newChallenge = {
         challengeID: challenge,
         id: res.data.data[0],
         startDate: new Date(),
         status: 1,
         userID: id
      }

      dispatch({
         type: ADD_CHALLENGE,
         details: newChallenge
      })

      return {
         success: true
      };

   } else {
      return {
         success: false,
      };
   }
}

export const GetMyChallenges = (status) => async (dispatch, getState) => {

   const res = await apiCallV2(
      "GET",
      "challenges/my-challenges",
      "",
      localStorage.getItem("access-token"),
      {},
      false
   );

   if (res.status == 200) {
      dispatch({
         type: SET_MY_CHALLENGES,
         list: res.data.data
      })
   }
}

export const LeaveChallenge = (challenge) => async (dispatch, getState) => {
   const res = await apiCallV2(
      "POST",
      "challenges/update-status",
      {
         challenge: challenge,
         status: 0
      },
      localStorage.getItem("access-token"),
   );

   if (res.status == 200 && res.data.status == 200) {
      const { myChallenges } = getState().Challenge;

      let newList = myChallenges.filter(mc => mc.challengeID != challenge);

      dispatch({
         type: SET_MY_CHALLENGES,
         list: newList
      })

      return {
         success: true
      }

   } else {
      return {
         success: false,
      };
   }
}

export const GetChallengeHistory = (challenge) => async (dispatch, getState) => {

   if (challenge?.statusType != "upcoming") {

      // const { challenges } = getState().Challenge;

      let filters = {
         startdate: challenge?.startdate,
         enddate: challenge?.enddate,
      }

      if (challenge?.type == "all") { //ALL TYPES OF WORKOUTS

      } else if (challenge?.type == "program") { // SPECIFIC PROGRAM - Pass Program ID
         filters = {
            ...filters,
            program_id: challenge?.program
         }
      } else if (challenge?.type == "steps") { // HEALTHKIT STEPS

      } else { // THIS IS EXPECTED/SHOULD BE PROGRAM TYPE
         filters = {
            ...filters,
            type: challenge?.type
         }
      }

      if (true) {
         const res = await apiCallV2(
            "GET",
            "challenges/get-challenge-history",
            "",
            localStorage.getItem("access-token"),
            {
               filters: {
                  ...filters
               }
            },
            false
         );

         dispatch({
            type: SET_MY_CHALLENGES_HISTORIES,
            list: res.data.data.workouts,
            label: "challenge-" + challenge?.id
         })

      } else {
      }
   }

}

export const SetChallengeToComplete = (challenge) => async (dispatch, getState) => {
   const { challenges, cached, myChallenges } = getState().Challenge;
   const { user } = getState().User;

   let uChallenge = myChallenges.filter(mc => mc.challengeID == challenge.id);
   const res = await apiCallV2(
      "POST",
      "challenges/update-status",
      {
         challenge: challenge.id,
         id: uChallenge[0]?.id,
         status: 2
      },
      localStorage.getItem("access-token"),
   );

   // const payload = {
   //    id: user?.id,
   //    firstName: user?.first_name,
   //    lastName: user?.last_name,
   //    gender: genderValueRev[user?.gender],
   //    age: getAge(new Date(user?.dob)),
   // }

   // const res2 = await servicesAPICall(
   //    "POST",
   //    "notification/post-workout-notification",
   //    {
   //       ...payload
   //    },
   //    localStorage.getItem("access-token")
   // );

}

